
import { useEffect, useRef, useState } from 'react';

export const useTextWidth = (width: number): { refText: React.MutableRefObject<null>, textWidth: number} => {
	const [textWidth, setTextState] = useState(width);
	const refText = useRef(null);

	useEffect((): void => {
		const element = refText.current ?? null;

		if (element !== null) {
			// eslint-disable-next-line dot-notation
			const newTextWidth = element['textLength']['baseVal']['value'];
			if (newTextWidth !== textWidth) {
				setTextState(newTextWidth);
			}
		}
	});

	return { refText, textWidth };
};
